import { Box, Heading, Text } from '@chakra-ui/react'
import Header from '../Header'
import PageTransition from '../components/PageTransition'

const TangentalAssets = (): JSX.Element => (
  <>
    <Header title="Tangental Assets" subtitle="Explore alternative investment options" />
    <PageTransition>
      <Box p={4}>
        <Heading as="h2" size="xl" mb={4}>Tangental Assets</Heading>
        <Text fontSize="md">This page will cover information on tangental and alternative assets for diversification.</Text>
      </Box>
    </PageTransition>
  </>
)

export default TangentalAssets
